<!-- =========================================================================================
  File Name: DashboardAnalytics.vue
  Description: Dashboard Analytics
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div class="relative mb-20 md:mb-0 ">
    <vx-card title="Type your question" class="mb-5 pb-4">
      <vs-input
      v-validate="'required|min:3|max:100'"
      data-vv-validate-on="blur"
      data-vv-as="question text"
      name="questionText"
      v-model.trim="currentQuestionText"
      placeholder="What do you want to ask?"
      size="large"
      class="w-full"></vs-input>
      <span class="text-danger text-sm my-2">{{ errors.first('questionText') }}</span>
      <div class="my-2 p-4" style="background: #FAFAFA">
        <p class="mb-3">Which customers should see this question?</p>
        <vs-slider class="w-full" :color="getSliderColor(ratingScale[0])" :min="0" :max="10" v-model="ratingScale" />
        <p class="my-1 text-sm">Only customers who give a rating of <span class="font-medium">{{ getRatingString(ratingScale[0],ratingScale[1]) }}</span> will see this.</p>
      </div>
    </vx-card>
    <vx-card title="Choose question type" class="mb-5 pb-4">
      <p class="mb-3">What kind of question would you like to ask?</p>
      <div class="vx-row lg:w-3/4">
        <div class="vx-col w-full md:w-1/3 my-6 md:my-0 md:px-2" v-if="isOpenQ">
          <vs-radio v-model="questionType" vs-value="openq" class="text-dark font-medium" >
          <img src="@/assets/images/misc/opentextanswer.png" class="w-full max-w-xs"/>
          <p class="text-center">Free-form text answer</p>
          </vs-radio>
        </div>
        <div class="vx-col w-full md:w-1/3 my-6 md:my-0 md:px-2" v-if="!isOpenQ">
          <vs-radio v-model="questionType" vs-value="singleq" class="text-dark font-medium">
          <img src="@/assets/images/misc/singlechoiceanswer.png" class="w-full max-w-xs"/>
          <p class="text-center">Single choice</p>
          </vs-radio>
        </div>
        <div class="vx-col w-full md:w-1/3 my-6 md:my-0 md:px-2" v-if="!isOpenQ">
          <vs-radio v-model="questionType" vs-value="multiq" class="text-dark font-medium">
          <img src="@/assets/images/misc/multiplechoiceanswer.png" class="w-full max-w-xs"/>
          <p class="text-center">Multiple choice</p>
          </vs-radio>
        </div>
      </div>
    </vx-card>
    <vx-card title="Choose possible answers" class="mb-5 pb-4" v-if="questionType !== 'openq'">
      <p class="mb-3">What options do you want as answers?</p>
      <div class="w-20">
        <div v-for="(option, i) in questionOptions">
          <vs-input
          v-validate="'min:1|max:20'"
          data-vv-validate-on="blur"
          data-vv-as="'option'"
          :name="'Option' + i"
          class="w-full sm:w-auto my-2 inline-block"
          v-model.trim="option.text"
          :placeholder="'Option ' + (i + 1)" />
          <vs-button type="flat" class="my-2 inline-block" v-if="i > 1" @click="removeQuestionOption(i)">x Remove</vs-button>
          <span class="block text-danger text-sm my-2">{{ errors.first('Option' + i) }}</span>
          <vs-divider class="sm:hidden"/>
        </div>
        <vs-button type="border" class="my-2" v-if="questionOptions.length < 5" @click="() => { questionOptions.push({text: ''}) }">+ Add option</vs-button>
      </div>
    </vx-card>
    <savebutton submitText="Update Question" :accept="updateQuestion" :goodToGo="formReady && formHasChanged" :cancel="cancel" />
  </div>
</template>


<script>

import Savebutton from './components/ptcomponents/Savebutton.vue'
import Pagesubtitle from './components/ptcomponents/Pagesubtitle.vue'

export default {
  data () {
    return {
      currentQuestionText: '',
      questionID: '',
      receivedData: false,
      isOpenQ: false,
      questionType: 'openq',
      ratingScale: [7,10],
      questionOptions: [{
        text: ''
      }, {
        text: ''
      }]
    }
  },
  components: {
    Savebutton,
    Pagesubtitle
  },
  computed: {
    formHasChanged() {
      if (JSON.stringify({
        questionID: this.questionID,
        questionType: this.questionType,
        currentQuestionText: this.currentQuestionText,
        questionOptions: this.questionOptions,
        ratingScale: this.ratingScale
      }) === this.receivedData) {
        return false
      }
      return true
    },
    formReady() {
      if (this.currentQuestionText.length > 0) {
        if (this.questionType !== 'openq') {
          let optionsGood = true
          this.questionOptions.forEach((o,i) => {
            if (i < 2) {
              if (o.text.length === 0) {
                  optionsGood = false
              }
            }
          })
          if (!optionsGood) {
            return false
          }
        }
        return true
      }
      return false
    }
  },
  created () {
  //check the route and load the right question:

    //noconsoleconsole.log('ROUTE ACTIVATED')

    let currentActiveQuestions = this.$store.state.dash.viewData.activeQuestions
    let currentEditID = this.$route.params.questionid
    let currentQuestion = false

    currentActiveQuestions.forEach((q) => {
      if (q.questionID === currentEditID) {
        currentQuestion = q
        //noconsoleconsole.log('active')
        //noconsoleconsole.log(q)
      }
    })

    let currentInActiveQuestions = this.$store.state.dash.viewData.inActiveQuestions
    currentInActiveQuestions.forEach((q) => {
      if (q.questionID === currentEditID) {
        currentQuestion = q
        //noconsoleconsole.log('INactive')
        //noconsoleconsole.log(q)
      }
    })
    //noconsoleconsole.log('current q')
    //noconsoleconsole.log(currentQuestion)

    if (currentQuestion === false) {
      this.$router.push('/dash/surveyflow')
      return
    }

    if (currentQuestion.questionType === 'openq') {
      this.isOpenQ = true
    } else {
      this.isOpenQ = false
    }

    this.questionID = currentQuestion.questionID
    this.questionType = currentQuestion.questionType
    this.currentQuestionText = currentQuestion.questionText

    if (typeof currentQuestion.ratingScale !== "undefined") {
      this.ratingScale = currentQuestion.ratingScale
    } else {
      this.ratingScale = [7,10]
    }

    let qOptions = [{
      text: ''
    }, {
      text: ''
    }]

    if (this.questionType !== 'openq') {
      qOptions = []
      currentQuestion.answerOptions.forEach((ao) => {
        qOptions.push({
          text: ao
        })
      })
      this.questionOptions = qOptions
    } else {
      this.questionOptions = [{
        text: ''
      }, {
        text: ''
      }]
    }

    this.receivedData = JSON.stringify({
      questionID: this.questionID,
      questionType: this.questionType,
      currentQuestionText: this.currentQuestionText,
      questionOptions: this.questionOptions,
      ratingScale: this.ratingScale
    })


  },
  methods: {
    getRatingString(min, max) {
      //if (min === 0 && max === 10) return ''
      return min === max ? min : min + ' - ' + max
    },
    getSliderColor(minRating) {
      return minRating <= 5 ? 'danger' : minRating <= 7 ? 'warning' : 'success'
    },
    cancel() {
      this.$router.push('/dash/surveyflow')
    },
    updateQuestion() {
      let payload

      let answerSetup = []

      this.questionOptions.forEach((o,i) => {
        if (o.text.trim() !== '') {
          answerSetup.push(o.text)
        }
      })

      let qDetail = {
        questionText: this.currentQuestionText,
        questionType: this.questionType,
        answerOptions: answerSetup,
        questionID: this.questionID,
        ratingScale: this.ratingScale
      }


      this.$store.dispatch('dash/UPDATE_QUESTION', qDetail).then(() => {
        this.$vs.notify({
          title:'Update question',
          text:'Question updated successfully',
          color:'success',
          time: 4000,
          iconPack: 'feather',
          icon:'icon-check'})
      }).catch(() => {
        this.$vs.notify({
          title:'Add new question',
          time: 10000,
          text:'Oops! Something went wrong, and we couldn\'t update your question. Please try again, or reach out for support if it happens again.',
          color:'warning',
          iconPack: 'feather',
          icon:'icon-alert-circle'})
      })

      this.$router.push('/dash/surveyflow')

    },
    removeQuestionOption(i) {
      this.questionOptions.splice(i,1)
    }
  }
}
</script>

<style lang="scss">



.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}


</style>
